<template>
  <div>
    <builderall-digital-file-repository
      :token="getOfficeToken()"
      :show="show"
      :accept="acceptTypes[accept]"
      inputid="ba-selected-file"
      showeditoption="true"
      v-if="show"
    />
    <input style="display: none;" type="text" id="ba-selected-file">

    <sweet-modal style="z-index: 10050" :title="`${$t('ct-toast-editor-image')}`" ref="editor-image" width="80%" height="80%" class="sweet-modal-theme-cheetah toast-editor-image" hide-close-button blocking>
      <div ref="tuiImageEditor"></div>
      <button
        slot="button"
        class="btn btn-outline-light mt-2"
        @click.prevent="$refs['editor-image'].close()"
      >{{ $t('ct-cancel')}}
      </button>
      <button
        slot="button"
        class="btn btn-success mt-2"
        @click.prevent="saveImage"
      >{{ $t('ct-save')}}
      </button>
    </sweet-modal>
  </div>
</template>

<script>
import {SweetModal} from 'sweet-modal-vue';
import TUIImageEditor from './toast-ui/TUIImageEditor.js';
import {mapGetters} from "vuex";
import axios from "axios";

require('./toast-ui/tui-color-picker.css');
require('./toast-ui/tui-image-editor.css');
require('./toast-ui/tui-image-editor-style.css');

export default {
  name: 'DigitalFileRepository',
  props: {
    show: {
      type: Boolean,
      required: true
    },
    accept: {
      type: String,
    },
    saveFile: {
      type: Function
    },
    closeFile: {
      type: Function
    }
  },
  components: {SweetModal, TUIImageEditor},
  data() {
    return {
      acceptTypes: {
          Images: '.png,.jpg,.jpeg,.gif,.svg,.webp',
          Files: '.png,.jpg,.jpeg,.gif,.pdf,.doc,.docx,.xsl,.ppt,.txt,.zip',
          Videos: '.mp4',
          mazSize: '',
      },
      editorToastUI: {
        data: {
          name : ''
        }
      },
      urlGfr: {
        id: '',
        url: '',
        secret: '',
      },
      gfrToken: ''
    }
  },
  created(){
    const gfr = {
        io: {
          id: 2,
          url: 'https://global-files.kub.app.builderall.io',
          secret: 'L26LyhzWiuBYgGIsc6BYeLRHFNZNC7zCgEalgbKS'
        },
        info: {
          id: 2,
          url: 'https://global-files.kub.app.builderall.info',
          secret: '4r9CLewttW8F9KLNCIlMM3JQiuVLLqs1ObbSafbM'
        },
        com: {
          id: 1,
          url: 'https://global-files.builderall.com',
          secret: 'A82YRH0Yq5YN54zghwaMCXWbQcid0MG2XI946wcW'
        },
    }
    const env = window.location.host.includes('.com') ? 'com' : (window.location.host.includes('.info') ? 'info' : 'io')
    this.urlGfr = gfr[env];
  },
  mounted(){
    this.getGfrToken();

    const textInput = document.getElementById('ba-selected-file');
    if(textInput){
      textInput.addEventListener('input', async (data) => {
        // Create file links with sitebuilder
        // await this.saveLinkImageTool(data.srcElement.value);

        // Save file in the event
        this.saveFile(data.srcElement.value);
      });
    }
    document.addEventListener("handle-close-global-file", (event) => {
      event.detail.show = false;
      this.closeFile();
    });
    document.addEventListener("edit-image", (event) => {
      this.editorImage(event.detail);
    });
  },
  methods: {
    ...mapGetters({ getOfficeToken: 'getOfficeToken' }),
    getGfrToken(){
      const formData = new FormData();
      formData.append('grant_type', 'client_credentials');
      formData.append('client_id', this.urlGfr.id);
      formData.append('client_secret', this.urlGfr.secret);

      axios.post(`${this.urlGfr.url}/oauth/token`, formData, {
          headers: {
              'Accept': 'application/json'
          }
      })
      .then(response => {
          this.gfrToken = response.data.access_token;
      })
      .catch(error => {
          console.error('Error to get global file repository token:', error);
      });
    },
    async saveLinkImageTool(url){
      const hash = url.split('/').pop();

      const formData = new FormData();
      formData.append('hash', hash);
      formData.append('application', 'website-builder');

      await axios.post(`${this.urlGfr.url}/v1/file-links/create`, formData, {
        headers: {
          'Accept': 'application/json',
          'Authorization': `Bearer ${this.gfrToken}`
        }
      })
      .then(response => {
          console.log('File linked -> ', response.data.message);
      })
      .catch(error => {
          console.error('Error to save link imgae:', error);
      });

      return true;
    },
    saveImage() {
      this.editorToastUI.imageEditor.stopDrawingMode();
      this.$loading.show();

      this.editorToastUI.onSave(
        (response) => {
          this.$loading.hide();
          this.$refs['editor-image'].close();
        }
      );
    },
    editorImage(file) {
      this.$loading.show();

      const dataFile = {
        'url': file,
        'name': file
      };

      this.editorToastUI = new TUIImageEditor(this.$refs.tuiImageEditor, this.urlGfr.url+'/v1/files/upload', this, dataFile, this.getOfficeToken());
      setTimeout(() => this.$loading.hide(), 1000);
      this.$refs['editor-image'].open();
    },
  }
};

</script>



// WEBPACK FOOTER //
// src/components/general/FilesManager/DigitalFileRepository.vue